import React from "react";
import PropTypes from "prop-types";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Box,
  Typography,
  Divider,
} from "@mui/material";
import { QRCodeCanvas } from "qrcode.react";
import SoftButton from "components/SoftButton"; // or use MUI Button if preferred

function ReceiptCodeDialog({ open, onClose, code, qrValue, uuid }) {
  // Ensure code is a 4-digit string (e.g., "0123")
  const paddedCode = String(code).padStart(4, "0").slice(0, 4);

  const qrUrl = `https://www.getverceipt.com/receipts/${uuid}`;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle
        sx={{
          textAlign: "center",
        }}
      >
        RECEIPT CODE
      </DialogTitle>

      <DialogContent
        sx={{
          fontFamily: '"Courier New", monospace',
          backgroundColor: "#fffef8",
          padding: 3,
        }}
      >
        {/* QR Code */}
        <Box display="flex" justifyContent="center" mb={2}>
          <QRCodeCanvas
            value={qrUrl}
            size={180}
            level="H"
            includeMargin={true}
          />
        </Box>

        {/* Divider with "OR" */}
        <Box display="flex" alignItems="center" my={2}>
          <Divider sx={{ flexGrow: 1, borderStyle: "solid" }} />
          <Typography
            variant="body2"
            sx={{ mx: 2, color: "#888", fontWeight: "bold" }}
          >
            OR
          </Typography>
          <Divider sx={{ flexGrow: 1, borderStyle: "solid" }} />
        </Box>

        {/* 4-Digit Code */}
        <Box display="flex" justifyContent="center" gap={2} mb={2}>
          {paddedCode.split("").map((digit, index) => (
            <Box
              key={index}
              sx={{
                border: "2px solid #000",
                borderRadius: "8px",
                width: "40px",
                height: "50px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "24px",
                fontWeight: "bold",
                fontFamily: '"Courier New", monospace',
                backgroundColor: "#fff",
              }}
            >
              {digit}
            </Box>
          ))}
        </Box>

        {/* Close Button */}
        <Box display="flex" justifyContent="center" gap={2} mt={5}>
        <SoftButton
            onClick={onClose}
            variant="outlined"
            size="small"
            color="secondary"
        >
            Close
        </SoftButton>
        </Box>
      </DialogContent>
    </Dialog>
  );
}

/* ✅ PropTypes */
ReceiptCodeDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  code: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  qrValue: PropTypes.string.isRequired,
  uuid: PropTypes.string.isRequired
};

export default ReceiptCodeDialog;
